export default "__VITE_ASSET__BQOlgkfB__"